import React from "react";
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import AncillaryExceptionContent from "./AncillaryExceptionContent";
import {Box} from "@mui/material";

const AncillaryExceptionContainer = () => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <Box>
            <SectionHeader title={t("translation:auths.SCOPE_PRC_VIEW_ANCILLARY_EXCEPTION.name")}/>
            <AncillaryExceptionContent readOnly={false}/>
        </Box>
    );
};

export default AncillaryExceptionContainer;